/* eslint-disable sonarjs/no-identical-functions, sonarjs/no-duplicate-string */
import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import {
  map,
  switchMap,
  catchError,
  tap,
  withLatestFrom,
} from 'rxjs/operators';

import {
  saveBrighterFederationPartnerData,
  saveBrighterFederationPartnerDataSuccess,
  saveBrighterFederationPartnerDataError,
} from './chcp-federation.actions';

import { of } from 'rxjs';

import { Router } from '@angular/router';

import { AuthFacade } from '@cigna/chcp/auth/data-access';
import { UserFacade } from '@cigna/chcp/shared/user-profile-data-access';
import { ChcpFederationService } from '../chcp-federation/chcp-federation.service';
import { WindowService } from '@cigna/shared/angular/core/window-util';

@Injectable()
export class ChcpFederationEffects {
  constructor(
    private actions$: Actions,
    private authFacade: AuthFacade,
    private userFacade: UserFacade,
    private chcpFederationService: ChcpFederationService,
    private window: WindowService,
    private router: Router,
  ) {}

  saveBrighterFederationPartnerData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(saveBrighterFederationPartnerData),
      withLatestFrom(this.authFacade.userid$, this.userFacade.userProfile$),
      switchMap(([, userId, userProfile]) => {
        const requestObj = {
          userId: userId || '',
        };
        return this.chcpFederationService
          .putFederationPartnerData(requestObj, 'brighter')
          .pipe(
            map(() => saveBrighterFederationPartnerDataSuccess()),
            catchError((error) =>
              of(saveBrighterFederationPartnerDataError({ error })),
            ),
          );
      }),
    ),
  );

  saveBrighterFederationPartnerDataSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(saveBrighterFederationPartnerDataSuccess),
        tap(() => {
          const queryParams = { key: 'brighter' };
          const urlTree = this.router.createUrlTree(['/linkrouter'], {
            queryParams,
          });
          const url = this.router.serializeUrl(urlTree);

          this.window.open(url, '_blank', 'noopener');
        }),
      ),
    { dispatch: false },
  );
}
